import React from "react";

const Header = () => {
  return (
    <div>
      <header>
        <h1 className="text-center text-7xl text-white" >Blogs</h1>
      </header>
    </div>
  );
};

export default Header;
